<template>
	<div class="container-fluid">
		<div class="m-2">
			<div class="alert alert-primary h4 text-center">
                <linkto :link="'/'"/>
                Raktár készlet
    		</div>
		</div>

		<div class="row d-flex justify-content-center">
			<div
				class="col-6 col-md-3 col-lg-2"
				v-for="(v,k) in innerMenu"
			>
				<button
					@click="setInventory(v.route)"
					class="btn"
					:class="[selectedLocation == v.route ? 'btn-primary' : 'btn-outline-primary']"
				>
					{{ v.title }}
				</button>
			</div>
		</div>

		<div
			class="row d-flex mt-2 mb-2"
			v-if="selectedLocation != '' && selectedLocation != undefined"
		>
			<div class="col-6 col-md-3 col-lg-2">
				<date-picker
					class="text-center disabled"
					v-model="filter.from"
					:config="date_options"
					placeholder="-tól"
				/>
			</div>
			<div class="col-6 col-md-3 col-lg-2">
				<date-picker
					class="text-center"
					v-model="filter.to"
					:config="date_options"
					placeholder="-ig"
				/>
			</div>
		</div>

		<div class="table-responsive" v-if="list.length > 0">
      		<table class="table">
				<thead class="thead-light">
		            <th>
		            	{{ filter.from }} - {{ filter.to }}
		            </th>
		            <th>Induló és összes beszállítás</th>
		            <th>Összes kisker eladás</th>
		            <th>Saját fogyasztás</th>
		            <th>Selejt</th>
		            <th>Transzfer</th>
		            <th>Összegzés</th>
		            
		        </thead>
			    <tbody>
			        <tr
			        	v-for="(v,k) in list"
			        	:key="k"
			        >
			        	<td>
			        		{{ v.nev }}
			        	</td>
			        	<td>
			        		{{ v.start }}
			        	</td>
			        	<td>
			        		<span v-if="v.order > 0">
			        			-
			        		</span>
			        		{{ v.order }}
			        	</td>
			        	<td>
			        		<span v-if="v.own > 0">
			        			-
			        		</span>
			        		{{ v.own }}
			        	</td>
			        	<td>
			        		<span v-if="v.selejt > 0">
			        			-
			        		</span>
			        		{{ v.selejt }}
			        	</td>
			        	<td>
			        		<span v-if="v.toother > 0">
			        			-
			        		</span>
			        		{{ v.toother }}
			        	</td>
			        	<td>
			        		{{ v.sum }}
			        	</td>
			        </tr>
			    </tbody>
			</table>
		</div>
	</div>
</template>

<script type="text/javascript">
export default {
	name: 'inventory_list',

	data(){
		return {
			innerMenu: [
				{
					title: 'Szeged',
					route: 'szeged'
				}
			],
			list: [],
			filter: {
				from: this.$moment(`${this.$moment().format('YYYY')}-01-01`).format('YYYY-MM-DD'),
				to: this.$moment().format('YYYY-MM-DD')
			}
		}
	},

	methods: {
		setInventory(route) {
			let query = Object.assign({}, this.$route.query)
			query.location = route
			this.$router.push({ query })
		},

		init() {
			this.$Progress.start()
			this.req.post('/stats/inventory/list',{
				location: this.selectedLocation,
				filter: this.filter
			})
				.then(res => {
					this.list = res.data.list
				  	this.$Progress.finish()
				})
				.catch(err => {
					console.log(err)
					this.$Progress.fail()
				})
		}
	},

	computed: {
		selectedLocation() {
			let query = Object.assign({}, this.$route.query)
			if(!query.location) return ''
			return query.location
		}
	},

	watch: {
		'$route'(to,from) {
			this.init()
		},

		filter: {
			deep: true,
			handler() {
				this.init()
			}
		}
	}
}
</script>


// WEBPACK FOOTER //
// src/components/inventory/list.vue